module.exports = __webpack_public_path__ + "img/tail-spin.fcad369b.svg";